import './assets/styles/cbi-style.css';
import Layout from './pages/Layout';
function App() {
  return (
    <Layout/>
  );
}

export default App;
